import { apiClient } from '../client';
import { API_ENDPOINTS } from '../config';

export async function markTourSeenOnServer(tourId: string): Promise<{
  ok: boolean;
  seen_tours?: string[];
  preferences?: Record<string, unknown>;
  error?: string;
}> {
  const id = typeof tourId === 'string' ? tourId.trim() : '';
  if (!id) return { ok: false, error: 'tour_id required' };

  const res = await apiClient.put<{
    seen_tours: string[];
    preferences: Record<string, unknown>;
  }>(`${API_ENDPOINTS.PROFILE}/tour-seen`, { tour_id: id });

  if (res.error || res.success === false) {
    return {
      ok: false,
      error: typeof res.error === 'string' ? res.error : 'Failed to save seen state',
    };
  }

  const data = (res.data ?? res) as {
    seen_tours?: string[];
    preferences?: Record<string, unknown>;
  };

  return { ok: true, seen_tours: data.seen_tours, preferences: data.preferences };
}
